export default __webpack_public_path__ + "static/media/seven.d4feb332.svg";